import {
  NycbsClientOutcome,
  NYCBS_RISA_IN_PROGRESS_FILTER_VALUE,
} from "../../table/utils/nycbsClientOutcome";

/** Filter options for the client-facing Outcome column. */
export const allNycbsClientOutcomeOptions = [
  {
    label: NycbsClientOutcome.RISA_IN_PROGRESS,
    value: NycbsClientOutcome.RISA_IN_PROGRESS,
  },
  {
    label: NycbsClientOutcome.WAITING_FOR_DETERMINATION,
    value: NycbsClientOutcome.WAITING_FOR_DETERMINATION,
  },
  { label: NycbsClientOutcome.AUTHORIZED, value: NycbsClientOutcome.AUTHORIZED },
  { label: NycbsClientOutcome.DENIED, value: NycbsClientOutcome.DENIED },
  {
    label: NycbsClientOutcome.AUTH_NOT_REQUIRED,
    value: NycbsClientOutcome.AUTH_NOT_REQUIRED,
  },
  { label: NycbsClientOutcome.ONSHORE, value: NycbsClientOutcome.ONSHORE },
  {
    label: NycbsClientOutcome.CALL_REQUIRED,
    value: NycbsClientOutcome.CALL_REQUIRED,
  },
];

export { NYCBS_RISA_IN_PROGRESS_FILTER_VALUE };
